<template>
  <v-row id="order-list">
    <v-col
      cols="12"
      class="px-0">
      <v-simple-table class="skus-table pa-3 pt-0">
        <thead>
          <tr>
            <th
              v-for="(head, index) in headers"
              :key="head.title"
              :style="`text-align: ${head.textAlign};`">
              <a
                :style="`cursor: ${head.sortAble ? 'pointer': 'default'};`"
                @click="head.sortAble ? sort(head, index) : () => {}">
                {{ head.title }}
                <v-icon
                  v-if="head.sortAble"
                  color="black"
                  size="16">
                  mdi-sort-alphabetical
                </v-icon>
              </a>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(order, i) in orders"
            :key="`order-${i}`">
            <td class="order-id-column">
              <u>
                <a @click="$router.push({ name: 'OrderDetail', params: { id: order.id } })">
                  {{ order.id }}
                </a>
              </u>
            </td>
            <td align="right">
              {{ order.net | showFullPriceFormat() }}
            </td>
            <td align="center">
              {{ order.createTime | localDate }}
            </td>
            <td
              class="column-status"
              align="center">
              <v-badge
                class="status-badge"
                content=""
                :value="true"
                dot
                left
                :color="displayOrderState(order).color">
                {{ displayOrderState(order).text }}
              </v-badge>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    orders: {
      type: Array,
      required: true,
      default: () => []
    },
    defaultSort: {
      type: Object,
      required: false,
      default: () => ({
        val: 'create_time',
        order: 'desc'
      })
    }
  },
  data () {
    return {
      headers: [
        {
          title: 'Order ID',
          sortAble: true,
          sortOrder: 'desc',
          textAlign: 'left',
          field: 'id'
        },
        {
          title: 'Net price',
          sortAble: false,
          sortOrder: 'desc',
          textAlign: 'right',
          field: 'net'
        },
        {
          title: 'Create Time',
          sortAble: true,
          sortOrder: 'desc',
          textAlign: 'center',
          field: 'create_time'
        },
        {
          title: 'Status',
          sortAble: false,
          sortOrder: 'desc',
          textAlign: 'center',
          field: 'current_state'
        }
      ],
      sortField: {}
    }
  },
  created () {
    this.sortField = this.defaultSort
  },
  methods: {
    displayOrderState (bill) {
      const now = new Date()
      const billExpire = new Date(bill.expire)
      if (bill.currentState) {
        switch (bill.currentState) {
          case 'paid':
            return { text: 'จัดส่งแล้ว', color: 'purple' }
          case 'confirmed': {
            if (now - billExpire > 0) {
              return { text: 'หมดอายุ', color: 'grey darken-1' }
            }
            if (bill.note && bill.note !== '') {
              return { text: 'รอแก้ไข', color: '#FB8C00' }
            }
            return { text: 'รอจัดส่ง', color: 'success' }
          }
          default: return { text: 'Unknow', color: 'grey darken-4' }
        }
      } else {
        return { text: 'Unknow', color: 'grey darken-4' }
      }
    },
    sort (head, index) {
      if (head.field === this.sortField.val) {
        this.headers[index].sortOrder = this.headers[index].sortOrder === 'desc' ? 'asc' : 'desc'
        this.sortField = {
          val: head.field,
          order: this.headers[index].sortOrder
        }
        this.$emit('onSortItem', { val: head.field, order: this.headers[index].sortOrder })
      } else {
        this.headers[index].sortOrder = 'desc'
        this.sortField = {
          val: head.field,
          order: 'desc'
        }
        this.$emit('onSortItem', { val: head.field, order: this.headers[index].sortOrder })
      }
    }
  }
}
</script>

<style>
.order-detail {
  cursor: pointer;
  text-align: center;
}
span.status-badge .v-badge__badge {
  left: 20px !important;
  top: 50% !important;
  transform: translateY(-50%);
}
span.v-badge.status-badge {
  position: static;
}
td.order-id-column a {
  color: #1976D2;
}
td.column-status {
  position: relative;
}

@media screen and (max-width: 767px) {
  div#order-list .skus-table table {
    width: 175%;
    overflow-y: scroll;
  }
}
</style>
